import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d6aqh4qdhb: FaireBrandEntity = {
  token: "b_d6aqh4qdhb",
  type: "brand",
  name: "Beefy's Own",
  avatarUrl:
    "https://cdn.faire.com/fastly/cded67a0479b085d32398f89745969d7c00a4912abdb51c169f4d22c14d39445.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d2152e6ac5a7e522996bc14594c58c18210c70a70c0c9950a2aa184d5ddf66b7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cded67a0479b085d32398f89745969d7c00a4912abdb51c169f4d22c14d39445.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d2152e6ac5a7e522996bc14594c58c18210c70a70c0c9950a2aa184d5ddf66b7.jpeg",
  location: "Derry, NH, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 30,
  isInsider: true,
  description:
    "Beefy's Own is the first modern company to fry potato chips in beef tallow. Founded in 2022, we set out to fill a gap in the market — bringing this time-honored, nutrient-rich cooking fat back to the snack aisle in a way that's never been done before.\n\nWe're a small, family-run operation that takes a lot of pride in what we make. Every batch is crafted with real ingredients and zero compromise on quality or flavor. We believe snacking and wellness can coexist — and our customers agree. Whether they're drawn to the clean ingredients or simply the unbeatable taste, Beefy's Own has built a loyal following of repeat buyers who keep coming back.\n\nWe'd love the opportunity to bring something genuinely different to your shelves - made the old school way, with a whole lot of heart behind it.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T21:11:42.471Z",
    importedBy: "entity-db-cli",
  },
};
